import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

import { EstimateSubmittedV1DataSchema } from "./estimate-review-shared";

const InsuranceElectiveEstimateSubmittedDataSchema = z.discriminatedUnion("version", [EstimateSubmittedV1DataSchema]);

export const InsuranceElectiveEstimateSubmittedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.INSURANCE_ELECTIVE_ESTIMATE_SUBMITTED),
  data: InsuranceElectiveEstimateSubmittedDataSchema,
});
